module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?$!../~/jquery/dist/jquery.js
// module id = 629
// module chunks = 0